import { apiSlice } from "./apiSlice";
import { CHAT_URL } from "../constants";

export const chatApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getChatRooms: builder.query({
      query: () => `${CHAT_URL}/rooms`,
      providesTags: ["Chat"],
    }),
    getChatRoom: builder.query({
      query: (id) => `${CHAT_URL}/rooms/${id}`,
      providesTags: ["Chat"],
    }),
    getChatUsers: builder.query({
      query: () => `${CHAT_URL}/users`,
    }),
    // ข้อความโหลดเองด้วย fetch ในหน้าจอ (ต่อท้าย/ย้อนหลังทีละหน้า) ไม่ผ่านแคชของ RTK
    createChatRoom: builder.mutation({
      query: (body) => ({ url: `${CHAT_URL}/rooms`, method: "POST", body }),
      invalidatesTags: ["Chat"],
    }),
    updateChatRoom: builder.mutation({
      query: ({ id, ...body }) => ({ url: `${CHAT_URL}/rooms/${id}`, method: "PUT", body }),
      invalidatesTags: ["Chat"],
    }),
    // รูปโปรไฟล์กลุ่ม (migration 125) — ส่งไฟล์ชื่อช่อง "files" ตามตัวรับไฟล์ของแชท
    setChatRoomAvatar: builder.mutation({
      query: ({ id, file }) => {
        const fd = new FormData();
        fd.append("files", file);
        return { url: `${CHAT_URL}/rooms/${id}/avatar`, method: "POST", body: fd };
      },
      invalidatesTags: ["Chat"],
    }),
    clearChatRoomAvatar: builder.mutation({
      query: (id) => ({ url: `${CHAT_URL}/rooms/${id}/avatar`, method: "DELETE" }),
      invalidatesTags: ["Chat"],
    }),
    addChatMembers: builder.mutation({
      query: ({ id, member_ids }) => ({ url: `${CHAT_URL}/rooms/${id}/members`, method: "POST", body: { member_ids } }),
      invalidatesTags: ["Chat"],
    }),
    removeChatMember: builder.mutation({
      query: ({ id, userId }) => ({ url: `${CHAT_URL}/rooms/${id}/members/${userId}`, method: "DELETE" }),
      invalidatesTags: ["Chat"],
    }),
    deleteChatMessage: builder.mutation({
      query: (id) => ({ url: `${CHAT_URL}/messages/${id}`, method: "DELETE" }),
    }),
    markChatRead: builder.mutation({
      query: ({ id, last_id }) => ({ url: `${CHAT_URL}/rooms/${id}/read`, method: "POST", body: { last_id } }),
      invalidatesTags: ["Chat"],
    }),
  }),
});

export const {
  useGetChatRoomsQuery,
  useGetChatRoomQuery,
  useGetChatUsersQuery,
  useCreateChatRoomMutation,
  useUpdateChatRoomMutation,
  useSetChatRoomAvatarMutation,
  useClearChatRoomAvatarMutation,
  useAddChatMembersMutation,
  useRemoveChatMemberMutation,
  useDeleteChatMessageMutation,
  useMarkChatReadMutation,
} = chatApiSlice;
